import { render, staticRenderFns } from "./ProblemDataList.vue?vue&type=template&id=67952ae8&scoped=true"
import script from "./ProblemDataList.vue?vue&type=script&lang=js"
export * from "./ProblemDataList.vue?vue&type=script&lang=js"
import style0 from "./ProblemDataList.vue?vue&type=style&index=0&id=67952ae8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67952ae8",
  null
  
)

export default component.exports